import type { ReactNode } from 'react';

export const symbol_bathtub: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M221.5-620.42q-21.5-21.42-21.5-51.5t21.42-51.58q21.42-21.5 51.5-21.5t51.58 21.42q21.5 21.42 21.5 51.5t-21.42 51.58q-21.42 21.5-51.5 21.5t-51.58-21.42ZM185.82-80Q168-80 154-91.5T140-120q-24.75 0-42.37-17.63Q80-155.25 80-180v-230q0-12.75 8.63-21.38Q97.25-440 110-440h90v-27.79Q200-503 225-528t60.38-25q18.62 0 35.62 7 17 7 30 21l52 59q7 8 14.5 14.5T433-440h307v-334q0-18.94-12.5-32.47Q715-820 696-820q-9.88 0-18.94 2T661-809l-52 52q5 17 1.5 34.5T598-689l-102-97q16.43-10.93 35.22-13.96Q550-803 568-796l52-51q15-15 34.54-24t41.46-9q43.79 0 73.89 31Q800-818 800-774v334h50q12.75 0 21.38 8.62Q880-422.75 880-410v230q0 24.75-17.62 42.37Q844.75-120 820-120q0 17-14 28.5T773-80H185.82ZM140-180h680v-200H140v200Zm0 0h680-680Z"
		/>
	</svg>
);
